import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { LicenseFamily } from '../../../../Organization/Types';
import ParticipantStore from '../../../../ParticipantStore';
import ParticipantsStore from '../../../../ParticipantsStore';
import {
  LoadingMore,
  Ready,
  Sorting,
  UpdatingQuery,
  UpdatingSearchParameters,
} from '../../../../ParticipantsStore/Types';
import { StringOption } from '../../../Options/Types';
import Actions from './Actions';
import Pagination from './Pagination';
import TableContent from './TableContent';

interface Props {
  participantsStore: ParticipantsStore;
  participantStores: ReadonlyArray<ParticipantStore>;
  selectedOrganization: Maybe<StringOption>;
  licenseFamily: LicenseFamily;
  participantsState: LoadingMore | Ready | UpdatingQuery | UpdatingSearchParameters | Sorting;
}

function View({ participantsStore, participantStores, licenseFamily, participantsState }: Props) {
  return (
    <div>
      <TableContent
        participantsStore={participantsStore}
        participantStores={participantStores}
        licenseFamily={licenseFamily}
      />
      <Pagination store={participantsStore} />
      <Actions store={participantsStore} participantsState={participantsState} />
    </div>
  );
}

export default observer(View);
